import styled from "styled-components";
import Hero from "src/components/Hero/Hero";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import TitleSection from "src/components/TitleSection/TitleSection";
import { LuAlarmClock } from "react-icons/lu";
import EventFinished from "src/components/EventFinished";

const MultiplierFridays2025 = () => {
  const { t, i18n } = useTranslation();

  return (
    <MultiplierFridays2025Div>
      <EventFinished
        scheduleKeyName="multiplierFridays2025"
        eventType="promotion"
      />
      <Hero
        bgImage="promotions/gaming-machines/multiplier-fridays-2025/Multiplier-Fridays-header-hero-image-2400x800px.jpg"
        buttonSettings={null}
        image={`promotions/gaming-machines/multiplier-fridays-2025/Multiplier-Fridays-logo-2400x2400px-${i18n.language}.png`}
        imageAlt={t("multiplierFridays2025.hero.title")}
        darkenBg={0.5}
        showArrow
        arrowBounce
      />
      <MainContentDiv>
        <container-div>
          <TitleSection
            as={"h2"}
            title={t("multiplierFridays2025.content.subtitle")}
            text={t("multiplierFridays2025.content.text")}
          />
          <Row className="g-4 mb-0 mt-0 align-items-center" id="">
            <Col className="mt-0 text-box p-3 mb-4" xs={12} md={12}>
              <ReactMarkdown className="desc">
                {t("multiplierFridays2025.content.description")}
              </ReactMarkdown>
            </Col>
          </Row>
          <Row className="periods-header">
            <Col>
              <LuAlarmClock />
              <TitleSection
                as={"h2"}
                title={t("multiplierFridays2025.content.giveawayPeriods.title")}
              />
            </Col>
          </Row>
          <Row className="multiplier-periods g-5">
            <Col xs={12} md={6} className="mb-4 mt-0 mb-md-0">
              <div className="period-box">
                <div className="time">{t("multiplierFridays2025.content.giveawayPeriods.time3x")}</div>
                <div className="multiplier">3X</div>
                <div className="points-label">
                  {t(
                    "multiplierFridays2025.content.giveawayPeriods.pointsLabel"
                  )}
                </div>
              </div>
            </Col>
            <Col xs={12} md={6} className="m-0">
              <div className="period-box">
                <div className="time">{t("multiplierFridays2025.content.giveawayPeriods.time2x")}</div>
                <div className="multiplier">2X</div>
                <div className="points-label">
                  {t(
                    "multiplierFridays2025.content.giveawayPeriods.pointsLabel"
                  )}
                </div>
              </div>
            </Col>
          </Row>
          {/* <Row className="periods-footer">
            <Col>
              <p className="every-friday">
                {t("multiplierFridays2025.content.giveawayPeriods.footer")}
              </p>
            </Col>
          </Row> */}
        </container-div>
      </MainContentDiv>
    </MultiplierFridays2025Div>
  );
};

const MultiplierFridays2025Div = styled.div`
  width: 100%;
  height: auto;
  background: var(--lightblack);
  color: var(--white);
  padding-bottom: 1rem;
  .hero_text_container {
    /* display: none; */
  }
  .hero_image {
    opacity: 0.9;
    margin: -2rem 0;
  }
  .small {
    text-align: center;
  }
  strong {
    color: #69d7e8;
  }
`;

const MainContentDiv = styled.div`
  padding-bottom: 1rem;
  @media (min-width: 768px) {
    padding: 2rem 1rem 1rem;
  }
  container-div {
    background-color: var(--lightblack);
  }
  @media (min-width: 992px) {
    padding: 3rem 0;
  }
  height: auto;
  width: 100%;
  ul {
    list-style: none;
    p {
      margin: 10px 0;
    }
    li {
      white-space: unset;
    }
  }
  .text-box {
    background-color: #2c363b;
    border-radius: 10px;
  }
  p {
    font-size: 1.22rem;
    text-align: center;
  }
  .row {
    display: flex;
    justify-content: space-between;
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
    .col-12 {
      .subtitle-section {
        @media (min-width: 768px) {
          padding-top: 0;
        }
      }
    }
  }
  div.periods-header {
    text-align: center;
    svg {
      margin: 20px 0 10px;
      color: var(--red);
      font-size: 40px;
    }
    h3 {
      font-size: 1.8rem;
      font-weight: 600;
      margin-bottom: 2rem;
    }
  }
  .multiplier-periods {
    max-width: 1200px;
    margin: 0 auto;
    padding-bottom: 1rem;

    .period-box {
      background-color: #2c363b;
      border-radius: 10px;
      padding: 2rem;
      text-align: center;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .points-label {
        font-size: 1.2rem;
        font-weight: 600;
        color: var(--white);
        text-transform: uppercase;
        margin-bottom: 0.5rem;
      }

      .multiplier {
        font-size: 5rem;
        font-weight: 700;
        color: #69d7e8;
        line-height: 1;

        @media (min-width: 768px) {
          font-size: 6rem;
        }
      }

      .time {
        font-size: 1rem;
        font-weight: 600;
        color: var(--white);

        @media (min-width: 768px) {
          font-size: 1.2rem;
        }
      }
    }
    @media (min-width: 768px) {
      padding-bottom: 2rem;
    }
  }
  .periods-footer {
    text-align: center;
    .every-friday {
      font-size: 1.3rem;
      font-weight: 600;
      color: var(--white);
    }
  }
`;

export default MultiplierFridays2025;
